import React from "react";

const ApplicationForm = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">

      <div className="w-full h-[90vh] bg-white rounded-xl shadow-lg overflow-hidden">
        <iframe
          src="/registration.pdf"  
          title="Application Form"
          className="w-full h-full"
        ></iframe>
      </div>

    </div>
  );
};

export default ApplicationForm;